import Cookies from "js-cookie";
import API from "./API";
import TenantAPI from "./TenantAPI";

export default class WorkflowAPI {
  static async getAllWorkflows() {
    return API._bearerRequest(
      "get",
      "/tenant/workflows",
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getWorkflowByID(workflowID) {
    return API._bearerRequest(
      "get",
      `/tenant/workflows/${workflowID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async createWorkflow(payload) {
    return API._bearerRequest(
      "post",
      "/tenant/workflows",
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateWorkflow(workflowID, payload) {
    return API._bearerRequest(
      "put",
      "/tenant/workflows/" + workflowID,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteWorkflow(workflowID) {
    return API._bearerRequest(
      "delete",
      "/tenant/workflows/" + workflowID,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
